module.exports = __webpack_public_path__ + "assets/lotterying-btn-light-49440276.svga";